import React from 'react';
import { Form } from 'antd';
import CustomerTextInput from '../../../inputs/customerTextInput/CustomerTextInput';
import DefaultButton from '../../../components/buttons/defaultButton/DefaultButton';
import useTranslation from '../../../../hooks/translation/useTranslation';
import CustomerSelectInput from '../../../inputs/customerSelectInput/CustomerSelectInput';

function LegalRegistrationFirstStepForm({
  form, handleSubmit, formValues, errors,
}) {
  const { trans, currentLanguage } = useTranslation();
  const accountNumber = Form.useWatch('bank_account_number', form);

  return (
    <Form layout="vertical" form={form} onFinish={handleSubmit}>
      <div className="flex flex-col lg:flex-row gap-4">
        <CustomerSelectInput
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
          options={formValues?.countries?.map((country) => ({
            value: country.id,
            label: country?.[`name_${currentLanguage === 'am' ? 'ka' : currentLanguage}`] || country.name_ka,
          }))}
          className="basis-1/2 white-background"
          name="country"
          label={trans('country')}
          errorMessage={errors?.country}
          search={false}
        />
        <CustomerTextInput
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }, {
            max: 9,
            min: 9,
            message: trans('number_length_{length}_validation')?.replace('{length}', 9),
          }]}
          type="number"
          className="flex-1"
          name="identification_number"
          label={trans('identification_number')}
          required
          errorMessage={errors?.identification_number}
        />
      </div>
      <div className="flex flex-col lg:flex-row gap-4">
        <CustomerSelectInput
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
          options={formValues?.organization_types?.map((organization) => ({
            value: organization.id,
            label: organization?.[`name_${currentLanguage === 'am' ? 'ka' : currentLanguage}`] || organization.name_ka,
          }))}
          className="basis-1/2 white-background"
          name="organization_type_id"
          label={trans('organization_type')}
          errorMessage={errors?.organization_type_id}
          search={false}
        />
        <CustomerTextInput
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
          className="flex-1"
          name="organization_name"
          label={trans('organization_name')}
          required
          errorMessage={errors?.organization_name}
        />
      </div>
      <div className="flex flex-col lg:flex-row gap-4">
        <CustomerTextInput
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }, {
            max: 22,
            min: 22,
            message: trans('number_length_{length}_validation')?.replace('{length}', 22),
          }, accountNumber?.length === 22 && {
            pattern: /^[A-Za-z]{2}\d{2}[A-Za-z]{2}\d{16}$/,
            message: trans('invalid_format'),
          }]}
          className="basis-1/2"
          name="bank_account_number"
          label={trans('bank_account_number')}
          required
          errorMessage={errors?.bank_account_number}
        />
        <CustomerTextInput
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
          className="flex-1"
          name="legal_address"
          label={trans('legal_address')}
          required
        />
      </div>
      <div className="flex gap-4">
        <DefaultButton
          type="submit"
          className="flex-1 text-base leading-[22px] h-[60px] mt-auto mb-6"
        >
          {trans('next')}
        </DefaultButton>
      </div>
    </Form>
  );
}
export default LegalRegistrationFirstStepForm;
